import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DeveloperSectionComponent } from './developer-section/developer-section.component';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { WhyHuiospayComponent } from './why-huiospay/why-huiospay.component';
import { CareersComponent } from './careers/careers.component';
import { FaqsComponent } from './faqs/faqs.component';
import { CustomerReviewComponent } from './customer-review/customer-review.component';
import { TrainingDevelopmentComponent } from './training-development/training-development.component';
import { QuickHelpComponent } from './quick-help/quick-help.component';
import { BecomeMerchantComponent } from './become-merchant/become-merchant.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { CourseDetailsComponent } from './course-details/course-details.component';
import { BecomeAgentComponent } from './become-agent/become-agent.component';
import { CheckoutComponent } from './checkout/checkout.component';
import { CookiesPolicyComponent } from './cookies-policy/cookies-policy.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { DataProtectionComponent } from './data-protection/data-protection.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { NewLandingPageComponent } from './new-landing-page/new-landing-page.component';
import { NewWhyHuiospayComponent } from './new-why-huiospay/new-why-huiospay.component';
import { NewDevelopersComponent } from './new-developers/new-developers.component';
import { NewAboutUsComponent } from './new-about-us/new-about-us.component';
import { NewCareersComponent } from './new-careers/new-careers.component';
import { NewSupportComponent } from './new-support/new-support.component';
import { NewTermsConditionsComponent } from './new-terms-conditions/new-terms-conditions.component';
import { NewPrivacyPolicyComponent } from './new-privacy-policy/new-privacy-policy.component';
import { NewDataProtectionComponent } from './new-data-protection/new-data-protection.component';

const routes: Routes = [
  // { path: '', component: LandingPageComponent },
  { path: '', component: NewLandingPageComponent },
  // { path: 'why-huiospay', component: WhyHuiospayComponent },
  { path: 'why-huiospay', component: NewWhyHuiospayComponent },
  { path: 'developers', component: NewDevelopersComponent },
  { path: 'developer-section', component: DeveloperSectionComponent },
  { path: 'faqs', component: FaqsComponent },
  { path: 'quick-help', component: QuickHelpComponent },
  { path: 'become-merchant', component: BecomeMerchantComponent },
  { path: 'become-agent', component: BecomeAgentComponent },
  { path: 'faqs', component: FaqsComponent },
  // { path: 'careers', component: CareersComponent },
  { path: 'careers', component: NewCareersComponent },
  { path: 'customer-review', component: CustomerReviewComponent },
  { path: 'training-and-development', component: TrainingDevelopmentComponent },
  // { path: 'about-us', component: AboutUsComponent },
  { path: 'about-us', component: NewAboutUsComponent },
  // { path: 'contact-us', component: ContactUsComponent },
  { path: 'support', component: NewSupportComponent },
  { path: 'course-details', component: CourseDetailsComponent },
  { path: 'checkout', component: CheckoutComponent },
  { path: 'cookies-policy', component: CookiesPolicyComponent },
  { path: 'privacy-policy', component: NewPrivacyPolicyComponent },
  { path: 'data-protection', component: NewDataProtectionComponent },
  { path: 'terms-and-conditions', component: NewTermsConditionsComponent },
  { path: '**', component: NewLandingPageComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class WebsiteRoutingModule {}
